var _defs, _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRef15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.28,45.06c-1.41,8.48-15.49,8.84-21.11,4.76l2.32-4.06c4.36,2.7,13.97,3.09,12.53-4.37-4.8,5.74-14.72,2.73-15.72-4.57-1.45-10.48,7.88-15.5,15.93-9.24v-2.59h6.05v20.08ZM38.31,31.18c-4.07,4.16,1.57,10.62,6.74,7.39,6.41-4-1.77-12.47-6.74-7.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.58,17.65v14.68l7.12-7.34h7.56l-8.16,8.48,8.16,12.68h-7.34l-5.4-8.2c-.29.38-1.94,1.78-1.94,1.94v6.26h-6.48v-28.5h6.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.67,24.67c9.18-.85,15.61,9.35,10.21,17.13-4.88,7.03-16.43,6.41-19.99-1.54-3.32-7.41,2.04-14.87,9.78-15.59ZM137.77,30.26c-4.98,1.15-5.06,10.51,1.26,11.11,7.97.76,7.81-13.2-1.26-11.11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.06,24.68c3.74-.4,7.73.87,10.45,3.55l-4.09,4.09c-2.45-3.25-8.83-2.95-9.94,1.3-1.84,7.06,5.36,10.13,10.32,5.66l3.73,3.22c-4.5,6.55-16.28,5.14-19.66-1.94s1.35-15.03,9.2-15.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.41,24.56v6.48c-2.57-.64-6.91,2.45-6.91,4.97v10.15h-6.48v-21.16h6.48c.24.86-.55,3.07.43,3.45.92-2.71,3.73-3.88,6.48-3.88Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.86,
    y: 24.99,
    width: 6.48,
    height: 21.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRef15);
export default __webpack_public_path__ + "static/media/ref15.b26596dc926f940b64739e5e428f85a8.svg";
export { ForwardRef as ReactComponent };